import { render, staticRenderFns } from "./ShowVersionHistory.vue?vue&type=template&id=c9092afa"
import script from "./ShowVersionHistory.vue?vue&type=script&lang=js"
export * from "./ShowVersionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports